// extracted by mini-css-extract-plugin
module.exports = {"benefitsItem":"Benefits_benefitsItem__3am56","text":"Benefits_text__1asrp","benefitsContainer":"Benefits_benefitsContainer__3HWUI","benefitsDots":"Benefits_benefitsDots__3ORkw"};